<template>
<div class="odr-toggle__content" :class="{'odr-toggle__content_closed': !eOpened}">
    <slot></slot>
</div>
</template>
<script>
import Vue from 'vue'
import { getParentToggleStore } from './toggle'

export default {
    props: {
        name: {
            type: String,
            _descr: 'name of content',
        },
    },
    data () {
        return {
            store: null,
            eName: this.name || null,
        }
    },
    mounted () {
        let parent = getParentToggleStore(this.$parent)
        this.store = parent.store
        this.eName = this.eName || parent.defaultName
        Vue.set(this.store, this.eName, !!this.store[this.eName])
    },
    computed: {
        eOpened () {
            return this.store ? this.store[this.eName] : false
        },
    },
}
</script>
